/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Speaker_Manager_Merge_Select_PlaceholderInputs */

const en_speaker_manager_merge_select_placeholder = /** @type {(inputs: Speaker_Manager_Merge_Select_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Select Speaker`)
};

const fr_speaker_manager_merge_select_placeholder = /** @type {(inputs: Speaker_Manager_Merge_Select_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Selectionner un locuteur`)
};

const de_speaker_manager_merge_select_placeholder = /** @type {(inputs: Speaker_Manager_Merge_Select_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sprecher auswählen`)
};

const it_speaker_manager_merge_select_placeholder = /** @type {(inputs: Speaker_Manager_Merge_Select_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seleziona altoparlante`)
};

const ru_speaker_manager_merge_select_placeholder = /** @type {(inputs: Speaker_Manager_Merge_Select_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Выберите динамик`)
};

const es_speaker_manager_merge_select_placeholder = /** @type {(inputs: Speaker_Manager_Merge_Select_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seleccionar orador`)
};

const zh_cn2_speaker_manager_merge_select_placeholder = /** @type {(inputs: Speaker_Manager_Merge_Select_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`选择发言人`)
};

const ja_speaker_manager_merge_select_placeholder = /** @type {(inputs: Speaker_Manager_Merge_Select_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`スピーカーを選択`)
};

const hi_speaker_manager_merge_select_placeholder = /** @type {(inputs: Speaker_Manager_Merge_Select_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`वक्ता का चयन करें`)
};

const pt_pt2_speaker_manager_merge_select_placeholder = /** @type {(inputs: Speaker_Manager_Merge_Select_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Selecione o alto-falante`)
};

/**
* | output |
* | --- |
* | "Select Speaker" |
*
* @param {Speaker_Manager_Merge_Select_PlaceholderInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const speaker_manager_merge_select_placeholder = /** @type {((inputs?: Speaker_Manager_Merge_Select_PlaceholderInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Speaker_Manager_Merge_Select_PlaceholderInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_speaker_manager_merge_select_placeholder(inputs)
	if (locale === "de") return de_speaker_manager_merge_select_placeholder(inputs)
	if (locale === "it") return it_speaker_manager_merge_select_placeholder(inputs)
	if (locale === "ru") return ru_speaker_manager_merge_select_placeholder(inputs)
	if (locale === "es") return es_speaker_manager_merge_select_placeholder(inputs)
	if (locale === "zh-CN") return zh_cn2_speaker_manager_merge_select_placeholder(inputs)
	if (locale === "ja") return ja_speaker_manager_merge_select_placeholder(inputs)
	if (locale === "hi") return hi_speaker_manager_merge_select_placeholder(inputs)
	if (locale === "pt-PT") return pt_pt2_speaker_manager_merge_select_placeholder(inputs)
	return en_speaker_manager_merge_select_placeholder(inputs)
});